import React from 'react';

export const cancelCircleOutline = () => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4ZM9.79289 9.79289C10.1834 9.40237 10.8166 9.40237 11.2071 9.79289L14 12.585L16.7929 9.79289C17.1534 9.43241 17.7206 9.40468 18.1129 9.7097L18.2071 9.79289C18.5976 10.1834 18.5976 10.8166 18.2071 11.2071L15.415 14L18.2071 16.7929C18.5676 17.1534 18.5953 17.7206 18.2903 18.1129L18.2071 18.2071C17.8166 18.5976 17.1834 18.5976 16.7929 18.2071L14 15.415L11.2071 18.2071C10.8466 18.5676 10.2794 18.5953 9.8871 18.2903L9.79289 18.2071C9.40237 17.8166 9.40237 17.1834 9.79289 16.7929L12.585 14L9.79289 11.2071C9.43241 10.8466 9.40468 10.2794 9.7097 9.8871L9.79289 9.79289Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const cancelOutline = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.26363 5.2636C5.6151 4.91213 6.18495 4.91213 6.53642 5.26361L12 10.7272L17.4636 5.26363C17.8151 4.91216 18.385 4.91216 18.7364 5.26363C19.0879 5.6151 19.0879 6.18495 18.7364 6.53642L13.2728 12L18.7364 17.4636C19.0879 17.8151 19.0879 18.385 18.7364 18.7364C18.3849 19.0879 17.8151 19.0879 17.4636 18.7364L12 13.2728L6.53639 18.7364C6.18492 19.0879 5.61507 19.0879 5.2636 18.7364C4.91213 18.3849 4.91213 17.8151 5.26361 17.4636L10.7272 12L5.26363 6.53639C4.91216 6.18492 4.91216 5.61507 5.26363 5.2636Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const cancelShieldOutline = () => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clipRule='evenodd'
        d='M14.516 1.50207C14.1664 1.45219 13.8336 1.45219 13.484 1.50207C13.1733 1.54641 12.9089 1.61377 12.3757 1.78793L5.36754 4.1234C4.55086 4.39563 4 5.15991 4 6.02077V15.3C4 20.2025 7.00734 23.9287 12.8264 26.4022C13.5763 26.721 14.4237 26.721 15.1736 26.4022L15.5419 26.2423C21.1216 23.7674 24 20.0944 24 15.3V6.02077C24 5.15991 23.4491 4.39563 22.6325 4.1234L15.8124 1.85005C15.1493 1.62902 14.8613 1.55133 14.516 1.50207ZM13.7665 3.48202C13.9287 3.45888 14.0713 3.45888 14.2335 3.48202L14.3551 3.5027C14.5024 3.53206 14.6814 3.5834 15.0231 3.69553L22 6.02077V15.3C22 19.2258 19.6408 22.2363 14.7381 24.411L14.3841 24.5647C14.1412 24.6679 13.8588 24.6679 13.6088 24.5616C8.47107 22.3777 6 19.316 6 15.3V6.02077L12.8201 3.74742C13.3784 3.56129 13.5666 3.51054 13.7665 3.48202ZM11.2071 9.79289C10.8166 9.40237 10.1834 9.40237 9.79289 9.79289C9.40237 10.1834 9.40237 10.8166 9.79289 11.2071L12.5858 14L9.79289 16.7929C9.40237 17.1834 9.40237 17.8166 9.79289 18.2071C10.1834 18.5976 10.8166 18.5976 11.2071 18.2071L14 15.4142L16.7929 18.2071C17.1834 18.5976 17.8166 18.5976 18.2071 18.2071C18.5976 17.8166 18.5976 17.1834 18.2071 16.7929L15.4142 14L18.2071 11.2071C18.5976 10.8166 18.5976 10.1834 18.2071 9.79289C17.8166 9.40237 17.1834 9.40237 16.7929 9.79289L14 12.5858L11.2071 9.79289Z'
        fill='#023F80'
      />
    </svg>
  );
};
